// Base gold prices in USD (will be converted based on selected currency)
// Updated with accurate market prices - March 2026
export const baseGoldPrices = [
  { id: 1, name: "GOLD GRAM", alias: "GRAM", basePrice: 139.87, spread: 0.5 },
  { id: 2, name: "GOLD OUNCE", alias: "GOLD", basePrice: 4350.00, spread: 2.0 },
  { id: 3, name: "SILVER OUNCE", alias: "SILVER", basePrice: 32.50, spread: 0.15 },
  { id: 4, name: "PLATINUM OUNCE", alias: "PLAT", basePrice: 1005.00, spread: 5.0 },
  { id: 5, name: "PALLADIUM OUNCE", alias: "PALL", basePrice: 970.00, spread: 10.0 },
  { id: 6, name: "GOLD KILO", alias: "KILO", basePrice: 139870.00, spread: 100.0 },
  { id: 7, name: "ELIZABETH SOVEREIGN", alias: "ELIZ", basePrice: 1105.00, spread: 15.0 },
];

// Currency symbols and formatting
export const currencyConfig = {
  USD: { symbol: '$', locale: 'en-US', decimals: 2, name: 'US Dollar' },
  EUR: { symbol: '€', locale: 'de-DE', decimals: 2, name: 'Euro' },
  TRY: { symbol: '₺', locale: 'tr-TR', decimals: 2, name: 'Turkish Lira' },
  AED: { symbol: 'د.إ', locale: 'ar-AE', decimals: 2, name: 'UAE Dirham' },
};

// Simulate random price fluctuations
export const getRandomFluctuation = (price, maxPercent = 0.05) => {
  const fluctuation = (Math.random() - 0.5) * 2 * maxPercent / 100 * price;
  return price + fluctuation;
};
